import * as m from 'framer-motion/m'
import { Container } from './Container'
import { ResponsiveImage } from './ResponsiveImage'

const CARDS = [
  {
    icon: 'attorney-1',
    iconAlt: 'Icon representing Clarity and Conviction',
    title: 'Clarity and Conviction',
    text: 'We believe performance stems from clarity — understanding value at its core. Our investment approach blends analytical precision with market intuition, allowing us to identify opportunities others overlook.',
    bg: 'linear-gradient(180deg, rgba(73,81,100,0.75) 0%, rgba(73,81,100,0.75) 100%)',
    titleClass: 'text-white',
    textClass: 'text-white/95',
  },
  {
    icon: 'attorney-2',
    iconAlt: 'Icon representing Alignment and Partnership',
    title: 'Alignment and Partnership',
    text: 'Partnership is central to everything we do. We invest alongside our partners, ensuring every decision, structure, and outcome is driven by shared success.',
    bg: 'linear-gradient(180deg, rgba(202,182,161,0.9) 0%, rgba(202,182,161,0.9) 100%)',
    titleClass: 'text-black',
    textClass: 'text-black/90',
  },
  {
    icon: 'attorney-3',
    iconAlt: 'Icon representing Rigour and Responsibility',
    title: 'Rigour and Responsibility',
    text: 'We approach every investment with institutional discipline — robust analysis, structured execution, and prudent risk management — while maintaining the agility and creativity of an entrepreneurial investment platform.',
    bg: 'linear-gradient(180deg, rgba(153,148,132,0.75) 0%, rgba(153,148,132,0.75) 100%)',
    titleClass: 'text-white',
    textClass: 'text-white/95',
  },
] as const

export function ValueCards() {
  return (
    <section className="relative z-10 bg-[#1e232b] px-6 sm:px-8 md:px-10 lg:px-12 pt-8 sm:pt-10 md:pt-12 pb-12 sm:pb-16 md:pb-20" aria-labelledby="values-heading">
      <h2 id="values-heading" className="sr-only">Our values</h2>
      <Container className="relative max-w-[1100px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 md:gap-10">
          {CARDS.map((card, i) => (
            <m.div
              key={card.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="p-6 sm:p-8 md:p-[48px] text-center rounded-xl shadow-2xl border border-white/10 min-w-0"
              style={{ backgroundImage: card.bg, backgroundSize: 'cover' }}
            >
              <div className="mx-auto w-[100px] sm:w-[130px] mb-3 sm:mb-4">
                <ResponsiveImage name={card.icon} alt={card.iconAlt} loading="lazy" fallbackExt="png" className="w-full h-auto" width={130} height={130} />
              </div>
              <h3 className={`uppercase ${card.titleClass} text-lg sm:text-[22px] md:text-[26px] leading-[1.4em] mb-2 sm:mb-3 font-serif`}>{card.title}</h3>
              <p className={`${card.textClass} leading-[1.8em] text-sm sm:text-[15px] md:text-[16px] font-sans`}>{card.text}</p>
            </m.div>
          ))}
        </div>
      </Container>
    </section>
  )
}
